export const PAYSLIP_REPORT_STATE = {
    report_month: ""
}